import React from "react";

const Totals = ({ orders }) => {
  return (
    <div className="flex justify-start items-start py-4 text-sm text-gray-800 leading-normal gap-6 w-auto">
      <ul className="space-y-1">
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total sale amount</b>
          <b className="text-center">:</b>
          <b className="text-end">
            {orders?.total_sale_amount
              ? orders?.total_sale_amount?.toLocaleString()
              : 0}
          </b>
        </li>
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total gross profit</b>
          <b className="text-center">:</b>
          <b className=" text-end">
            {orders?.total_customers
              ? orders?.total_gross?.toLocaleString()
              : 0}
          </b>
        </li>
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total sale order</b>
          <b className="text-center">:</b>
          <b className=" text-end">
            {orders?.total_sale_order_count
              ? orders?.total_sale_order_count?.toLocaleString()
              : 0}
          </b>
        </li>
      </ul>
      <ul className="space-y-1">
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total customer count</b>
          <b className="text-center">:</b>
          <b className=" text-end">
            {orders?.total_customers
              ? orders?.total_customers?.toLocaleString()
              : 0}
          </b>
        </li>
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total sessions</b>
          <b className="text-center">:</b>
          <b className=" text-end">
            {orders?.total_live_sale_sessions
              ? orders?.total_live_sale_sessions?.toLocaleString()
              : 0}
          </b>
        </li>
        <li className="grid grid-cols-[2fr_1fr_1fr] gap-2">
          <b className="flex items-center">Total quantity sold</b>
          <b className="text-center">:</b>
          <b className=" text-end">
            {orders?.total_product
              ? orders?.total_product?.toLocaleString()
              : 0}
          </b>
        </li>
      </ul>
    </div>
  );
};

export default Totals;
